"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component } from "vue-property-decorator";
let VirtualDesktopEmpty = class extends Vue {
  constructor() {
    super(...arguments);
    this.arrow = require("../../../../assets/img/vd-desktop-empty/arrow.png");
    this.vdBuy = require("../../../../assets/img/vd-desktop-empty/vd-buy.png");
    this.shopAdd = require("../../../../assets/img/vd-desktop-empty/shop-add.png");
    this.shopStart = require("../../../../assets/img/vd-desktop-empty/shop-start.png");
  }
  openExplain() {
    window.open("https://www.kuajingvs.com/one-minute/");
  }
};
VirtualDesktopEmpty = __decorateClass([
  Component({
    components: {}
  })
], VirtualDesktopEmpty);
export {
  VirtualDesktopEmpty as default
};
